/**
 * IndexedDB adapter 위에 localStorage 레거시 값 1회 마이그레이션
 *
 * @param {{ get: Function, set: Function, id?: string }} primaryAdapter
 */
export function withLocalStorageMigration(primaryAdapter) {
  const migratedKeys = new Set();

  const migrateFromLocalStorage = async key => {
    if (migratedKeys.has(key) || typeof localStorage === 'undefined') {
      return null;
    }
    migratedKeys.add(key);
    const legacy = localStorage.getItem(key);
    if (legacy == null) {
      return null;
    }
    const parsed = parseInt(legacy, 10);
    if (Number.isNaN(parsed)) {
      return null;
    }
    await primaryAdapter.set(key, parsed);
    localStorage.removeItem(key);
    return parsed;
  };

  return {
    id: primaryAdapter.id ? `${primaryAdapter.id}-migrated` : 'drawer-width-migrated',

    async get(key) {
      const stored = await primaryAdapter.get(key);
      if (stored != null) {
        return stored;
      }
      return migrateFromLocalStorage(key);
    },

    async set(key, width) {
      await primaryAdapter.set(key, width);
    }
  };
}
